import { render, staticRenderFns } from "./InvoiceCreateEditLogo.vue?vue&type=template&id=2646056f&scoped=true&"
import script from "./InvoiceCreateEditLogo.vue?vue&type=script&lang=js&"
export * from "./InvoiceCreateEditLogo.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCreateEditLogo.vue?vue&type=style&index=0&id=2646056f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2646056f",
  null
  
)

export default component.exports